import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Flex from '@magalu/stereo-ui/atoms/Flex';
export var SectionSeller = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 12px;\n"])));